/** Decorative drifting colour blobs behind the top of every page. */
export function Aurora() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-x-0 top-0 -z-10 h-[38rem] overflow-hidden">
      <div
        className="absolute -left-32 -top-48 size-[34rem] rounded-full blur-3xl animate-aurora"
        style={{ background: 'radial-gradient(circle, hsl(var(--brand-1) / var(--aurora-opacity)), transparent 68%)' }}
      />
      <div
        className="absolute -right-40 -top-32 size-[30rem] rounded-full blur-3xl animate-aurora"
        style={{
          animationDelay: '-7s',
          background: 'radial-gradient(circle, hsl(var(--kagami) / var(--aurora-opacity)), transparent 68%)',
        }}
      />
      <div
        className="absolute left-1/3 top-24 size-[24rem] rounded-full blur-3xl animate-aurora"
        style={{
          animationDelay: '-14s',
          background: 'radial-gradient(circle, hsl(var(--brand-3) / calc(var(--aurora-opacity) * 0.6)), transparent 68%)',
        }}
      />
      <div className="absolute inset-0 grid-backdrop" />
    </div>
  )
}
